import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import PayroleStructure from "../../components/payrole-processor/PayroleStructure";

const PayroleProcessor = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return <PayroleStructure userInfoData={userInfoData} />;
};

export default PayroleProcessor;
